import React from 'react'
import { Container } from 'components/Layout'
import cn from 'classnames'
import s from './Section.scss'
import sLay from 'styles/modules/layout.scss'
import getDetailFromColor from '../../Utils/getDetailFromColor'
import imgPattern from 'static/images/pattern.png'

export default props => {
  const {
    color,
    children,
    paddingTop,
    paddingBottom,
    className,
    style,
    fullHeight,
    sectionWidth,
    pattern,
    ...otherProps
  } = props
  const colorDetail = getDetailFromColor(color)
  return (
    <div
      className={cn(
        s.section,
        sLay['layout-column'],
        sLay['layout-align-center'],
        { [s.fullHeight]: fullHeight },
        className
      )}
      style={{ ...style, backgroundColor: colorDetail.background, color: colorDetail.text }}
      {...otherProps}
    >
      {pattern && <div className={s.pattern} style={{ backgroundImage: `url(${imgPattern})` }} />}
      <Container
        className={cn(s.inner, sectionWidth)}
        style={{
          paddingTop,
          paddingBottom,
        }}
      >
        {children}
      </Container>
    </div>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/Section/Section.jsx